// extracted by mini-css-extract-plugin
export default {"portfolioPlace":"SecTwo_portfolioPlace__ZIoA5","productItem":"SecTwo_productItem__fZEXO","hover":"SecTwo_hover__BBbke","name":"SecTwo_name__e-eOR","title":"SecTwo_title__LdgXg"};